import { useEffect, useState } from "react";
import { Dialog, Snackbar } from "@material-ui/core";
import { get, uniqueId } from "lodash";
import MuiAlert from "@material-ui/lab/Alert";
import ReactHtmlParser from "react-html-parser";

import "./AppointmentCard.scss";
import { AppointmentCardDetails } from "./AppointmentCardDetails";
import { maxTabletScreenWidth, toastLength } from "../../../services/constants";
import { journeyStore } from "../../../stores/journey-store";
import { getHighlightTextSearchMarkup } from "../../../helpers/highlighterHelpers";

const hasNumber = (myString) => /\d/.test(myString);

const retNumber = (myString) => {
  let num = myString.replace(/[^0-9]/g, "");
  return parseInt(num, 10);
};

export const AppointmentCard = (props) => {
  const {
    title,
    description,
    card_key,
    can_book_from_portal,
    virtual,
    last_card,
    appointmentCardToShow,
    event,
    group_class,
    searchText,
  } = props;

  const [openDialog, setOpenDialog] = useState(false);
  const [responseError, setResponseError] = useState(null);
  const [appointmentSelected, setAppointmentSelected] = useState(null);
  let firstParagraph = false;
  let firstList = false;
  const isNotEventOrGroup = !event && !group_class;
  const selectedTitle = hasNumber(title)
    ? `${
        title.toLowerCase().includes("postpartum") ? "POSTPARTUM" : ""
      } WEEK ${retNumber(title)} APPOINTMENT`
    : title;

  const highlightedTitleText = getHighlightTextSearchMarkup(
    selectedTitle,
    searchText
  );

  useEffect(() => {
    if (appointmentCardToShow?.card_key === card_key) {
      setAppointmentSelected(appointmentCardToShow);
    } else {
      setAppointmentSelected(null);
    }
  }, [appointmentCardToShow]);

  const handleClickOpen = () => {
    if (window.innerWidth < maxTabletScreenWidth) {
      setOpenDialog(true);
    } else {
      journeyStore.setAppointmentCardToShow(props);
    }
  };

  const Alert = (props) => {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setResponseError(null);
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  return (
    <>
      <div
        className={`appointment-card ${
          appointmentSelected?.card_key === card_key
            ? "appointment-card-selected"
            : ""
        }`}
        onClick={() => handleClickOpen()}
      >
        {appointmentSelected?.card_key === card_key && (
          <img
            className="arrow-pointer"
            src="/icons/Arrow-Left-Material-Filled.png"
            alt="arrow-left-icon"
          />
        )}
        <div className="appointment-title">
          <img
            className="icon"
            src="/icons/calendar@0,5x.svg"
            alt="calendar-icon"
          />
          {ReactHtmlParser(highlightedTitleText)}
        </div>

        {event && (
          <div style={{ marginBottom: "10px" }}>
            <span className="event-label">Event</span>
          </div>
        )}

        {group_class && (
          <div style={{ marginBottom: "10px" }}>
            <span className="group-class-label">Group Class</span>
          </div>
        )}

        {virtual && can_book_from_portal && isNotEventOrGroup && (
          <div style={{ marginBottom: "10px" }}>
            <div className="virtual-label">Virtual</div>
          </div>
        )}

        {!virtual && can_book_from_portal && isNotEventOrGroup && (
          <div style={{ marginBottom: "10px" }}>
            <div className="office-visit-label">Office Visit</div>
          </div>
        )}

        {description && (
          <div className="appointment-description">
            {description.map((section) => {
              if (get(section, "paragraph") && !firstParagraph) {
                const higlightedText = getHighlightTextSearchMarkup(
                  section.paragraph,
                  searchText
                );

                firstParagraph = true;

                return (
                  <p
                    className="appointment-description-paragraph"
                    key={uniqueId()}
                  >
                    {ReactHtmlParser(higlightedText)}
                  </p>
                );
              } else {
                if (get(section, "list") && !firstList && !firstParagraph) {
                  const higlightedText = getHighlightTextSearchMarkup(
                    section.list.title,
                    searchText
                  );

                  firstList = true;
                  return (
                    <div key={uniqueId()} className="appointment-list-column">
                      <div>
                        <p>{ReactHtmlParser(higlightedText)}</p>
                      </div>
                      <ul>
                        {section.list.items.map((item, index) => {
                          if (index < 2) {
                            const higlightedText = getHighlightTextSearchMarkup(
                              item,
                              searchText
                            );

                            return (
                              <li
                                className="appointment-description-list-item"
                                key={index}
                              >
                                {ReactHtmlParser(higlightedText)}
                              </li>
                            );
                          } else if (index === 1) {
                            return "...";
                          }
                        })}
                      </ul>
                    </div>
                  );
                }
              }
            })}
            <a
              onClick={() => {
                handleClickOpen();
              }}
            >
              expand
            </a>
          </div>
        )}
        {!last_card && <div className="vertical-line-appointment" />}
      </div>

      {openDialog && (
        <Dialog fullScreen open={openDialog} onClose={handleClose}>
          <AppointmentCardDetails
            handleClose={handleClose}
            searchText={searchText}
            {...props}
          />
        </Dialog>
      )}

      <Snackbar
        open={responseError}
        autoHideDuration={toastLength}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleSnackbarClose} severity="error">
          {responseError}
        </Alert>
      </Snackbar>
    </>
  );
};
